/**
 * Offline Initialization Service
 * Initializes all offline services when the app starts
 */

import offlineStorage from './storage.service';
import networkMonitor from './network-monitor.service';
import syncManager from './sync-manager.service';
import { profileCache } from '../cache/profileCache';
import logger from '../../utils/logger';

export const initializeOfflineSupport = async (): Promise<void> => {
  try {
    logger.info('Initializing offline support...');

    // Initialize storage
    await offlineStorage.init();
    logger.info('Offline storage initialized');

    // Initialize network monitoring
    await networkMonitor.init();
    logger.info('Network monitoring initialized');

    // Start auto sync
    syncManager.startAutoSync();
    logger.info('Auto sync started');

    // Start profile cache auto cleanup
    profileCache.startAutoCleanup();
    logger.info('Profile cache auto cleanup started');

    logger.info('Offline support initialized successfully');
  } catch (error) {
    logger.error('Failed to initialize offline support:', error);
    // Don't throw - app should work even if offline support fails
  }
};

export const cleanupOfflineSupport = (): void => {
  try {
    syncManager.stopAutoSync();
    networkMonitor.destroy();
    profileCache.destroy();
    logger.info('Offline support cleaned up');
  } catch (error) {
    logger.error('Error cleaning up offline support:', error);
  }
};